import React from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import { useStoreState } from 'easy-peasy';
import { isNull } from 'lodash';
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import client from '../../../utils/apolloClient';

const deleteServiceMutation = gql`
  mutation deleteServiceMenu($input: NavigateServiceTypeInput) {
    delete_service_type(input: $input) {
      service_type_id
      name
      error {
        description
      }
    }
  }
`;

const GlobalMenuUpdate = ({ serviceId, disabled }) => {
  const { userId } = useStoreState(state => state.auth);

  return (
    <Mutation
      client={client.clientPrivate}
      mutation={deleteServiceMutation}
      onCompleted={({ delete_service_type }) => {
        if (!isNull(delete_service_type.error)) {
          delete_service_type.error.map(item => toast.error(item.description));
        } else {
          toast.success('Service type deleted successfully!');
          window.location.reload(true);
        }
      }}
    >
      {(delete_service_type, { loading }) => (
        <button
          className={`button ${loading && 'is-loading'}`}
          disabled={disabled}
          onClick={() => {
            swal({
              title: 'Are you sure?',
              // eslint-disable-next-line max-len
              text: `Are you sure you want to delete this Service type`,
              buttons: ['Cancel', 'Yes'],
              dangerMode: true,
            }).then(willDelete => {
              if (willDelete) {
                delete_service_type({
                  variables: {
                    input: {
                      user_id: userId,
                      service_type_id: serviceId,
                    },
                  },
                });
              }
            });
          }}
        >
          <i className="fas fa-trash has-text-grey" id="Delete_ServiceType" />
        </button>
      )}
    </Mutation>
  );
};

export default GlobalMenuUpdate;
